import {Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;

  padding: 0 24px;
`;

export const LottieContainer = styled.View`
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(12)}px;
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-bottom: ${getBottomSpace() && Platform.OS === 'ios'
    ? 0
    : RFValue(20)}px;
`;
